'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    // this.store = new HierarchicalStore(props.store, context && context.store, props.storeContext);
    var _this = _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props, context));

    _this.store = props.store;
    _this.createStore = _this.props.createStore;

    return _this;
  }

  _createClass(Provider, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.close();
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        store: this.store,
        createStore: this.createStore
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Provider;
}(_react.Component);

exports.default = Provider;

Provider.contextTypes = {
  store: _propTypes2.default.object
};
Provider.childContextTypes = {
  store: _propTypes2.default.object,
  createStore: _propTypes2.default.func
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/pyradux/lib/Provider.js
// module id = 498
// module chunks = 1